<template>
  <a-modal
    title="导入"
    ref="createModal"
    :width="900"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirmValidate"
    :confirmLoading="confirmLoading"
  >
    <!-- <template #title>
      <span>导入 </span>
      <a-tooltip placement="topLeft">
        <template slot="title">
          <p>ID列数据请保留，如需新增时复制已有行，请先删除所复制行对应的“id”列数据；</p>
          <p>  表格头带“*”列为必填字段；</p>
          <p>  “生效日期”列请输入某月第一天的日期；</p>
          <p> “失效日期”请输入某月最后一天的日期。</p>
        </template>
        <a-icon type="question-circle" theme="twoTone" />
      </a-tooltip>
    </template> -->
    <a-form-model
      ref="ruleForm"
      :model="commitdata"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      :rules="rules"
      class="full-width"
    >
      <a-form-model-item label="分配集名称" prop="assignmentSetId">
        <global-select
          @successCallBack="assignmentSetIdSCHandler"
          ref="assignmentSetNameGS"
          @change="handleVersionChange"
          :value.sync="commitdata.assignmentSetId"
          selectType="selectSearch"
          searchParam="inputString"
          requestApi="/mdm/mdmOrgSrAssignmentSets/selectList"
          :selectItem="{ value: 'selectedValue', label: 'label' }"
        />
      </a-form-model-item>
      <a-form-model-item label="期间" prop="forecastMonthTem">
        <a-range-picker
          class="rp-width"
          :placeholder="['开始日期', '结束日期']"
          valueFormat="YYYY-MM"
          format="YYYY-MM"
          :value="commitdata.forecastMonthTem"
          :mode="mode"
          @panelChange="handlePanelChange"
        />
      </a-form-model-item>

      <a-form-model-item label="上传文件" prop="fileList">
        <a-upload :file-list="commitdata.fileList" :remove="handleRemove" :before-upload="beforeUpload">
          <a-button> <a-icon type="upload" />上传文件</a-button> <span class="col-tips">支持扩展名：.xls .xlsx...</span>
        </a-upload>
      </a-form-model-item >
    </a-form-model>
  </a-modal>
</template>

  <script>
// import { apiCreateShipmentForecast } from '@/api/scp/salesForecast/salesForecastWorkDesk'
import axios from 'axios'
import Cookies from 'js-cookie'
import moment from 'moment';

// 表单字段
export default {
  props: {
    uomClassOptions: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      spuItemCodeSetParams: {
        forecastName: ''
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      // 表单校验
      rules: {
        // forecastMonthTem: [{ required: true, message: '预测期间不能为空', trigger: 'change' }],
        assignmentSetId: [{ required: true, message: '分配集不能为空', trigger: 'change' }],
        forecastMonthTem: [{ required: true, message: '期间不能为空', trigger: 'change' }],
        fileList: [{ required: true, message: '上传文件不能为空', trigger: 'change' }]
      },
      queryParams: {
        // 预测名称
        forecastName: undefined,
        startMonth: ''
      },
      commitdata: {
        monthStart: '', // 预测起始月
        monthEnd: '', // 预测起始月
        forecastMonthTem: [], // 临时时间
        forecastName: '', // 预测名称
        versionCode: '', // 版本
        versionDescription: '', // 版本描述
        scpBusinessUnit: '', // 事业部
        file: '', // 文件流
        fileList: []
      },
      inputType: 1,
      mode: ['month', 'month'],
      // 状态数据字典
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      typeList: [],
      unitOfMeasureList: []
    }
  },
  created () {},
  methods: {
    assignmentSetIdSCHandler (val) {
          if (val) { this.queryParams.assignmentSetId = val[0].lookUpCode }
     },
    handlePanelChange (value, mode) {
      const yearMonth1 = value[0].format('YYYY-MM')
      let yearMonth2 = value[1].format('YYYY-MM')
      if (this.yearMonthTem !== yearMonth1) {
        const yearAfter5MonthMoment = moment(yearMonth1, 'YYYY-MM').add(4, 'months');

        const yearAfter5Month = yearAfter5MonthMoment.format('YYYY-MM');
        yearMonth2 = yearAfter5Month
        value[1] = yearAfter5MonthMoment
      }
      this.commitdata.monthStart = yearMonth1
      this.commitdata.monthEnd = yearMonth2
      this.commitdata.forecastMonthTem = value
      this.yearMonthTem = yearMonth1
    },
    handleForecastName (val, selectList) {
      this.commitdata.versionCode = ''
      this.commitdata.versionDescription = ''
      //     debugger
      //   const filteredItem = selectList.filter(item => item.realValue === val);
      //  this.commitdata.versionDescription = filteredItem[0].bringOutDataOne
    },
    handlerRangPicker (val, selectList) {
      if (val) {
        const filteredItem = selectList.filter(item => item.selectedValue === val);
        this.commitdata.forecastName = filteredItem[0].bringOutDataOne
        this.commitdata.forecastMonthStart = filteredItem[0].label
        this.commitdata.forecastMonthEnd = filteredItem[0].realValue
        const forecastPeriodFromData = new Date(this.commitdata.forecastMonthStart).toISOString();
        const forecastPeriodToData = new Date(this.commitdata.forecastMonthEnd).toISOString();
        this.commitdata.forecastMonthTem = [forecastPeriodFromData, forecastPeriodToData];
      } else {
        this.commitdata.forecastName = undefined;
      }
    },
    handleVersionChange (val, selectList) {
      if (val) {
        const filteredItem = selectList.filter((item) => item.realValue === val)
        this.commitdata.versionDescription = filteredItem[0].bringOutDataOne
      } else {
        this.commitdata.versionDescription = undefined
      }
    },
    handleRemove (file) {
      this.commitdata.fileList = []
    },
    beforeUpload (file) {
      this.$message.success('已添加文件')
      this.commitdata.fileList = [file]
      return false
    },
    show () {
      // this.addLine()
      this.visible = true
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    confirmValidate () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirm()
        }
      })
    },
    confirm () {
          this.confirmLoading = true
          const token =
            process.env.NODE_ENV === 'development' || localStorage.getItem('isFromSystemLogin') === 'true'
              ? localStorage.getItem('token')
              : Cookies.get('Admin-Token')
          const Authorization = token ? 'Bearer ' + token : undefined
          const uploadUrl = process.env.VUE_APP_API_BASE_URL + '/mdm/mdmOrgSrAssignments/importNew'
          const formData = new FormData()
          formData.append('file', this.commitdata.fileList[0])
          formData.append('assignmentSetId', this.commitdata.assignmentSetId)
          // formData.append('scpBusinessUnit', this.commitdata.scpBusinessUnit)
          formData.append('monthStart', this.commitdata.monthStart)
          formData.append('monthEnd', this.commitdata.monthEnd)
          axios
            .post(uploadUrl, formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: Authorization
              }
            })
            .then((response) => {
              if (response.data.code === 200) {
              this.$message.success(response.data.msg)
              this.confirmLoading = false
              // 关闭本组件
              this.visible = false
              // 调用外部刷新列表方法
              this.$emit('handle-success')
              // 刷新表单
              this.reset()
              } else if (response.data.code === 400) {
                this.$message.warning(response.data.msg)
                this.confirmLoading = false
                // 关闭本组件
                this.visible = false
              } else {
                this.$message.warning(response.data.msg)
                this.confirmLoading = false
              }
            })
            .catch((error) => {
              this.$message.error(error)
              this.confirmLoading = false
            })
      // this.commitdata.dtoList = this.typeList
      // this.commitdata.type = (this.inputType === 2 ? 'Y' : 'N')
      // apiCreateShipmentForecast(this.commitdata).then(response => {
      //   if (response.code === 200) {
      //     this.$message.success('新增成功')
      //     // 关闭本组件
      //     this.visible = false
      //     // 调用外部刷新列表方法
      //     this.$emit('handle-success')
      //     // 刷新表单
      //     this.reset()
      //     this.confirmLoading = false
      //   } else {
      //     this.$message.error(response.msg)
      //     this.confirmLoading = false
      //   }
      // }).catch(e => {
      //   this.confirmLoading = false
      // })
    },
    // 表单重置
    reset () {
      this.commitdata = {
        forecastName: '', // 预测名称
        forecastMonthStart: '', // 预测起始月
        forecastMonthEnd: '', // 预测起始月
        forecastMonthTem: [], // 临时时间
        dtoList: [] // 列表数据
      }
      this.typeList = []
    }
  }
}
</script>

  <style scoped lang="less">
/deep/.ant-select {
  width: 180px;
}
/deep/.ant-input {
  width: 180px;
}
/deep/.ant-modal-body {
  height: 400px;
  overflow-y: scroll;
}
.rp-width {
  width: 200px;
}
.ip-width {
  width: 150px;
}
.full-width {
  width: 100%;
}
.col-tips {
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4470588235294118);
  line-height: 22px;
}
</style>
